import { isEmptyModifierValue, unsupportedPreview } from "./index";

export function formatDate(
    value: unknown,
    format: string | undefined,
): unknown {
    if (isEmptyModifierValue(value) || !format) return value;
    if (typeof value !== "string") return unsupportedPreview;
    const match =
        /^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2})(?::(\d{2})(?:\.(\d{1,6}))?)?(Z|[+-]\d{2}:?\d{2})?)?$/.exec(
            value,
        );
    if (!match) return unsupportedPreview;
    const [
        ,
        year = "",
        month = "",
        day = "",
        hour = "00",
        minute = "00",
        second = "00",
    ] = match;
    const date = new Date(
        `${year}-${month}-${day}T${hour}:${minute}:${second}Z`,
    );
    if (
        Number.isNaN(date.getTime()) ||
        date.toISOString().slice(0, 19) !==
            `${year}-${month}-${day}T${hour}:${minute}:${second}`
    )
        return unsupportedPreview;
    const name = (options: Intl.DateTimeFormatOptions) =>
        new Intl.DateTimeFormat("en", { ...options, timeZone: "UTC" }).format(
            date,
        );
    const tokens: Record<string, string> = {
        Y: year,
        y: year.slice(-2),
        m: month,
        n: String(Number(month)),
        d: day,
        j: String(Number(day)),
        H: hour,
        G: String(Number(hour)),
        h: String(Number(hour) % 12 || 12).padStart(2, "0"),
        g: String(Number(hour) % 12 || 12),
        i: minute,
        s: second,
        a: Number(hour) < 12 ? "am" : "pm",
        A: Number(hour) < 12 ? "AM" : "PM",
        D: name({ weekday: "short" }),
        l: name({ weekday: "long" }),
        F: name({ month: "long" }),
        M: name({ month: "short" }),
        N: String(date.getUTCDay() || 7),
        w: String(date.getUTCDay()),
    };
    let unsupported = false;
    const result = format.replace(
        /\\([\s\S])|([a-zA-Z])/g,
        (_, literal, token) => {
            if (literal !== undefined) return literal;
            if (tokens[token] === undefined) unsupported = true;
            return tokens[token] ?? token;
        },
    );
    return unsupported ? unsupportedPreview : result;
}
